export const Colors = [
  {description: 'information', value: '#0077CC'},
  {description: 'information light', value: '#0077CC4D'},
  {description: 'success', value: '#57B747'},
  {description: 'warning', value: '#F9AF7D'},
  {description: 'danger', value: '#DB2828'},
];
